<template>
    <div>
        <van-nav-bar
                :title="title"
                left-arrow
                @click-left="toSales"
        >
            <bv-icon slot="right" icon-class="list" @click="menuClick"/>
        </van-nav-bar>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(image, index) in imageList" :key="index">
                    <div class="image-cell">
                        <van-image fit="cover" height="210px" width="100%" :src="imageImg(image)"/>
                        <div class="sale-desc">
                            已网签备案：{{cellSummary.sellNum}} &nbsp;&nbsp;&nbsp;&nbsp; 待网签备案：{{cellSummary.nosaledNum}} &nbsp;&nbsp;&nbsp;&nbsp;
                            自留/非卖：{{cellSummary.nosaleNum}}
                        </div>
                    </div>
                </van-swipe-item>
            </van-swipe>
            <van-panel v-for="floor in floors" :key="floor.floorNo">
                <bv-floor slot="header" :title="floor.floorName" :summary="floor"/>
                <van-row>
                    <div>
                        <bv-house
                                v-for="room in floor.rooms"
                                :key="room.houseId"
                                :showName="room.showName"
                                :area="room.constructArea"
                                :price="room.presellPrice"
                                :color="room.colorCode"
                                :state="room.presellState"
                                @click="() => showRoom(room)"
                        />
                    </div>
                </van-row>
            </van-panel>
        </van-pull-refresh>
        <van-popup
                v-model="popupShow"
                position="right"
                :style="{ width: '80%',height: '100%' }"
        >
            <div>
                <van-nav-bar
                        title="请选择楼幢和单元"
                />
                <van-tree-select
                        :items="bldCells"
                        :main-active-index="mainActiveIndex"
                        :active-id="activeId"
                        @navclick="onNavClick"
                        @itemclick="onItemClick"
                        slot="right"
                        :height="height"
                />
            </div>
        </van-popup>
        <van-popup v-model="roomShow" class="popup-room">
            <van-card>
                <div slot="title" class="title"><span class="show-name">{{ room.showName }}</span><span
                        class="presell-state"><van-tag>{{room.houseUse}}</van-tag><van-tag>{{room.presellState}}</van-tag></span>
                </div>
                <div slot="desc" class="desc">
                    <div class="desc-info">
                        <p><span>建筑面积：</span><span><span v-text="room.constructArea"/>㎡</span></p>
                        <p><span>套内面积：</span><span><span v-text="room.ownArea"/>㎡</span></p>
                        <p><span>户型：</span><span><span v-text="room.houseHold"/></span></p>
                        <p v-show="room.presellPrice > 0 && room.presellState.indexOf('非卖') == -1 && room.presellState.indexOf('自留') == -1 ">
                        <span><span
                                class="base-desc">备案价格：</span></span><span><span>{{room.presellPrice}}元/㎡</span></span>
                        </p>
                    </div>
                    <!--<div class="desc-image">
                        <van-image src="http://222.74.69.146:180/file/group1/M00/00/11/CgoMAV0XYPeAbikjAAKqWOwRkKQ628.jpg" @click="onImage" />
                    </div>-->
                </div>
            </van-card>
        </van-popup>
    </div>
</template>

<script>
    import {Swipe, SwipeItem, Image, NavBar, Panel, TreeSelect, Popup, Toast, Tag, Card, ImagePreview} from 'vant'
    import Floor from '../components/Floor'
    import House from '../components/House'
    import {regionBldCells, cellHouses} from '@/api/houseResource/house'

    export default {
        name: 'BuildingView',
        components: {
            VanSwipe: Swipe,
            VanSwipeItem: SwipeItem,
            VanImage: Image,
            VanNavBar: NavBar,
            VanPanel: Panel,
            BvFloor: Floor,
            BvHouse: House,
            VanTreeSelect: TreeSelect,
            VanPopup: Popup,
            VanTag: Tag,
            VanCard: Card
        },
        data() {
            return {
                title: '',
                building: null,
                cell: null,
                //左侧弹出层显示
                popupShow: false,
                bldCells: [],
                mainActiveIndex: 0,
                activeId: 1,
                floors: [],
                projectId: '',
                bldNo: '',
                isLoading: false,
                imageList: [],
                cellSummary: {},
                height: window.innerHeight,

                // 显示房屋信息
                roomShow: false,
                // 当前弹层显示的房屋信息
                room: {}
            }
        },
        methods: {
            //全屏加载提示
            showLoading() {
                Toast.loading({
                    // 持续展示 toast
                    duration: 0,
                    mask: true,
                    message: '加载中...'
                });
            },
            initBldCells() {
                this.showLoading();
                let _vm = this;
                let param = {
                    regionId: this.$route.query.regionId,
                    houseShow: this.$route.query.houseShow
                };

              regionBldCells(param).then(res => {
                const bldCells = res.data; // 接口返回的楼栋列表
                _vm.bldCells = bldCells;

                // 1. 寻找第一个包含有效单元的楼栋
                let targetBld = null;
                let targetCell = null; // 存储找到的第一个有效单元
                for (let i = 0; i < bldCells.length; i++) {
                  const bld = bldCells[i];
                  // 检查楼栋是否有单元列表，且至少有一个单元的 cellNo 有值
                  if (bld.listCell && bld.listCell.length > 0) {
                    // 在当前楼栋中寻找第一个 cellNo 有值的单元
                    const validCell = bld.listCell.find(cell => cell.cellNo);
                    if (validCell) {
                      targetBld = bld;
                      targetCell = validCell;
                      break;
                    }
                  }
                }

                if (targetBld && targetCell) {
                  // 使用找到的楼栋和单元数据
                  _vm.projectId = targetBld.projectId;
                  console.log("projectId111==========" + _vm.projectId);
                  _vm.bldNo = targetBld.bldNo;
                  _vm.activeId = targetCell.cellNo; // 使用有效单元的 cellNo

                  // 拼接标题
                  const title = _vm.$route.query.houseShow;
                  _vm.title = title
                      ? targetCell.bldName + '#' + targetCell.cellName + '(' + title + ')'
                      : targetCell.bldName + '#' + targetCell.cellName;

                  // 准备请求单元房屋数据的参数
                  let param = {
                    projectId: _vm.projectId,
                    bldNo: _vm.bldNo,
                    cellNo: _vm.activeId,
                    houseShow: _vm.$route.query.houseShow
                  };

                  // 调用单元房屋接口
                  cellHouses(param).then(resp => {
                    _vm.floors = resp.data.listFloorSummary;
                    _vm.imageList = resp.data.imageList;
                    _vm.cellSummary = resp.data.cellSummary;
                    Toast.clear();
                  }).catch(err => {
                    console.error('获取单元房屋数据失败', err);
                    Toast.clear();
                  });
                } else {
                  // 没有任何楼栋有有效单元数据
                  console.warn('当前项目下没有楼栋或单元数据（或所有单元编号为空）');
                  Toast.clear();
                  // 清空相关展示数据
                  _vm.bldCells = [];
                  _vm.activeId = null;
                  _vm.title = '暂无数据';
                  _vm.floors = [];
                  _vm.imageList = [];
                  _vm.cellSummary = null;
                }
              }).catch(err => {
                console.error('获取楼栋单元数据失败', err);
                Toast.clear();
              });
            },
            menuClick() {
                this.popupShow = true
            },
            onImage() {
                ImagePreview({
                    images: [
                        'http://222.74.69.146:180/file/group1/M00/00/11/CgoMAV0XYPeAbikjAAKqWOwRkKQ628.jpg'
                    ],
                    //页面退出时自动关闭
                    closeOnPopstate: true,
                    showIndex: false
                });
            },
            toSales() {
                this.$router.push({
                    path: '/houseResource/sales',
                    query: {
                        regionId: this.$route.query.regionId,
                        regionName: this.$route.query.regionName,
                        from: this.$route.query.from
                    }
                });
            },
            onNavClick(index) {
                this.bldNo = this.bldCells[index].bldNo
                this.mainActiveIndex = index;
                this.activeId = this.bldCells[index].children[0].id
            },
            onItemClick(data) {
                const title = this.$route.query.houseShow;
                this.title = title?data.bldName + '#' + data.cellName+'('+title+')':data.bldName + '#' + data.cellName;
                this.showLoading();
                //let _vm = this;
                this.popupShow = false;
                this.activeId = data.id;
                this.projectId = data.projectId;
                this.bldNo = data.bldNo;
                let param = {
                    projectId: data.projectId,
                    bldNo: data.bldNo,
                    cellNo: this.activeId,
                    houseShow: this.$route.query.houseShow
                };
                cellHouses(param).then(resp => {
                    this.floors = resp.data.listFloorSummary;
                    this.imageList = resp.data.imageList;
                    this.cellSummary = resp.data.cellSummary;
                    Toast.clear();
                });
            },
            showRoom(room) {
                this.roomShow = true
                this.room = room
            },
            imageImg(logoPath) {
                return logoPath != null ? logoPath : require('@/assets/nothing.png');
            },
            //下拉刷新
            onRefresh() {
                let param = {
                    projectId: this.projectId,
                    bldNo: this.bldNo,
                    cellNo: this.activeId,
                    houseShow: this.$route.query.houseShow
                };
                cellHouses(param).then(resp => {
                    this.floors = resp.data.listFloorSummary;
                    this.imageList = resp.data.imageList;
                    this.cellSummary = resp.data.cellSummary
                    this.isLoading = false;
                });
            }
        },
        mounted() {
            this.initBldCells();
            this.height = window.innerHeight - 100;
        }
    }
</script>
<style lang="scss">
    .image-cell {
        text-align: center;
        width: 100%;
        height: 100%;
        .sale-desc {
            position: absolute;
            width: 100%;
            height: 15%;
            bottom: 0px;
            color: white;
            font-size: 14px;
            //background-color: black;
            //opacity: 0.5;
            background-color: rgba(0, 0, 0, 0.6);
            text-align: center;
            line-height: 30px;
        }
    }
</style>
